import { ComplianceCaseTypeEnum } from "~/graphql/supergraphEnums";
import { isInternalEscalationSource } from "../../utils/constants";

/** Source case types whose escalation fans out per client, so the impacted-client preview is shown. */
const IMPACTED_GP_PREVIEW_CASE_TYPES: readonly string[] = [
  ComplianceCaseTypeEnum.RecurringHit,
  ComplianceCaseTypeEnum.PaymentInstructionChangeReview,
  ComplianceCaseTypeEnum.InvestorOnboarding,
  ComplianceCaseTypeEnum.Remediation,
  ComplianceCaseTypeEnum.ChangeInCircumstance,
  ComplianceCaseTypeEnum.DocumentRefresh,
  ComplianceCaseTypeEnum.ProfileRefresh,
];

/** Source case types where the escalated profile is fixed, so no profile selector is offered. */
const PROFILE_SELECT_HIDDEN_CASE_TYPES: readonly string[] = [
  ComplianceCaseTypeEnum.RecurringHit,
  ComplianceCaseTypeEnum.DocumentRefresh,
  ComplianceCaseTypeEnum.ProfileRefresh,
  ComplianceCaseTypeEnum.ChangeInCircumstance,
];

export const showsImpactedGpPreview = (caseType?: string | null): boolean =>
  !!caseType && IMPACTED_GP_PREVIEW_CASE_TYPES.includes(caseType);

export const showsEscalationPreview = (caseType?: string | null): boolean =>
  isInternalEscalationSource(caseType) || showsImpactedGpPreview(caseType);

export const showsProfileSelect = (caseType?: string | null): boolean =>
  !caseType || !PROFILE_SELECT_HIDDEN_CASE_TYPES.includes(caseType);
